import { useState } from 'react';
import '../index.css';

const faqs = [
  {
    icon: '💻',
    q: 'Funciona em Mac, Windows e Linux?',
    a: 'Sim! Funciona em qualquer sistema operacional com Chrome, Edge ou Brave. Basta instalar a extensao e comecar a usar.'
  },
  {
    icon: '🛡️',
    q: 'Minha conta pode ser banida?',
    a: 'Nao. O metodo e seguro e validado por centenas de usuarios ha meses. A extensao opera de forma discreta e segura.'
  },
  {
    icon: '📦',
    q: 'Como recebo a extensao?',
    a: 'Apos o pagamento, voce recebe o link de download + chave de licenca por email em ate 5 minutos. Instalacao em menos de 2 minutos.'
  },
  {
    icon: '🔄',
    q: 'E se parar de funcionar apos um update do Lovable?',
    a: 'A extensao PODE PARAR DE FUNCIONAR a qualquer momento. Como e um metodo nao oficial que explora brechas, a Lovable constantemente atualiza e corrige essas brechas. Fazemos o possivel para atualizar, mas NAO HA GARANTIA. Voce assume esse risco ao comprar.'
  },
  {
    icon: '⚠️',
    q: 'Tem garantia?',
    a: 'NAO. Este e um metodo NAO OFICIAL e voce assume todos os riscos. A extensao pode parar de funcionar a qualquer momento pois a Lovable sempre atualiza e corrige brechas. Nao ha reembolso. So compre se estiver CIENTE e DE ACORDO com essas condicoes.'
  },
  {
    icon: '⏰',
    q: 'Preciso renovar todo mes?',
    a: 'Depende do plano escolhido. Cada plano tem sua duracao especifica (diario, semanal ou mensal). Ao final do periodo, basta renovar para continuar usando.'
  },
  {
    icon: '🚀',
    q: 'Quantos projetos posso criar?',
    a: 'Ilimitados! A extensao permite criar, editar e publicar quantos projetos quiser durante o periodo do seu plano.'
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section className="faq-section">
      <div className="section-inner">
        <h2 className="section-title">
          <span className="title-icon">&#10067;</span> Perguntas Frequentes
        </h2>
        <p className="section-subtitle">Tire suas duvidas antes de garantir sua extensao</p>

        <div className="faq-list">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className={`faq-item ${open === i ? 'faq-open' : ''}`}
              onClick={() => setOpen(open === i ? null : i)}
            >
              <div className="faq-question">
                <span className="faq-icon">{faq.icon}</span>
                <span className="faq-text">{faq.q}</span>
                <span className="faq-arrow">{open === i ? '−' : '+'}</span>
              </div>
              {open === i && (
                <div className="faq-answer">
                  <div className="faq-answer-content">{faq.a}</div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
